/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from "react";
import {AEButton} from "../../../../../_emywork/components/buttons";
import {AESVG} from "../../../../../_emywork/components/svg";
import {Dropdown} from "react-bootstrap";
import {AEMetadata, useMetadata} from "../../../../../_emywork/AEPagination";
import {useModuleContext} from "../../ModuleContext";
import {ProposalDetailsModal} from "../../dialogs/ProposalDetailsModal";
import {useIntl} from "react-intl";
import {PROPOSALS} from "../../../../../_emywork/helpers/UIHelper";
import {EntityCard as UserEntityCard} from "../../../Users/componants/EntityCard";
import {AECurrency} from "../../../../../_emywork/components/Currency";
import MockUtils from "../../../../../_emywork/mock.utils";
import {EmyProposalStatus} from "../../componants/Status";
import {getProposalStatuses, PROPOSAL_STATUSES} from "../../helpers/StatusHelpers";

const initMetadata = new AEMetadata({},{field:'user_id'})
const mockUtil = new MockUtils()

export function Proposals({ className, entities = [], onCloseModal }) {
  const [activeTab, setActiveTab] = useState(PROPOSAL_STATUSES.PENDING.key);
  const {sortField, sortAsc, setSort} = useMetadata(initMetadata);
  const {openProposalDetailsDialog} = useModuleContext()
  const {formatMessage} = useIntl()

  const SortField = ({field, title, sortable = false})=>{
    const isSame = sortField === field;

    return (
      <AEButton
        variant={isSame ? 'link-primary': 'light'}
        className={'p-0'}
        onClick={()=>{
          if(sortable){
            setSort(field, !sortAsc)
          }

        }}
      >
        {title}
        {
          isSame &&
          <AESVG
            path={`/Navigation/${sortAsc ? 'Arrow-down':'Arrow-up'}.svg`}
            variant={isSame ? 'primary':''}
          />
        }

      </AEButton>
    )
  }


  const dataset = entities.filter(e=>e.status === activeTab);
  return (
    <>
      <ProposalDetailsModal onSave={onCloseModal}/>
      {/* begin::Base Table Widget 6 */}
      <div className={`card card-custom ${className}`}>
        {/* begin::Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title">
            <span className="card-label font-weight-bolder text-dark">
              {formatMessage({id:'PROPOSALS'})}
            </span>
            <Dropdown className="dropdown-inline" drop="down" alignRight >
              <Dropdown.Toggle
                variant="transparent"
                className="btn btn-link-primary btn-sm font-weight-bolder dropdown-toggle text-capitalize">
                <EmyProposalStatus status={activeTab} />
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                {
                  getProposalStatuses().map(elem=>(
                    <Dropdown.Item
                      key={elem.key}
                      onClick={() => setActiveTab(elem.key)}
                      // className={`text-capitalize label label-inline label-dark ${activeTab === elem.key ? 'text-primary':''}`}
                    >
                      <EmyProposalStatus status={elem.key} />
                    </Dropdown.Item>
                  ))
                }
              </Dropdown.Menu>
            </Dropdown>
            {/*<span className="text-muted mt-3 font-weight-bold font-size-sm">*/}
            {/*  More than 400+ new members*/}
            {/*</span>*/}
          </h3>
          <div className="card-toolbar">
            {/*<div className="input-icon mr-2">*/}
            {/*  <input*/}
            {/*    type="text"*/}
            {/*    className="form-control form-control-sm form-control-solid"*/}
            {/*    placeholder={formatMessage({id:'SEARCH'})}*/}
            {/*    autoComplete="false"*/}
            {/*  />*/}
            {/*  <AESVG path={'/General/Search.svg'} />*/}
            {/*</div>*/}
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body pt-2 pb-0">
          {/* begin::Table */}
          <div className="table-responsive">
            <table className="table table-head-custom table-vertical-center table-head-bg table-borderless">
              <thead>
                <tr className="text-left">
                  <th  className="pl-7">
                    <SortField field={'user_id'} title={formatMessage({id:'ROLE_PROVIDER'})} sortable/>
                  </th>
                  <th>
                    <SortField field={'price'} title={formatMessage({id:'PRICE'})} sortable/>
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
              {
                mockUtil
                  .sortArray(dataset, sortField, sortAsc ? "asc" : "desc")
                  .map(({id, created_by, price})=>(
                    <tr key={id}>
                      <td className="">
                        <UserEntityCard
                          entity={created_by}
                          size={"xs"}
                          className={'mb-0'}
                        />
                        {/*<ProviderEntityCard entity={created_by} size={"xs"}/>*/}
                      </td>
                      <td>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">
                          <AECurrency value={price} />
                        </span>
                        {/*<span className="text-muted font-weight-bold">*/}
                        {/*    In Proccess*/}
                        {/*  </span>*/}
                      </td>
                      <td className="pr-0 text-right">
                        <AEButton
                          variant={'light-primary'}
                          fontWeight={'bolder'}
                          size={'sm'}
                          onClick={()=>{
                            openProposalDetailsDialog(id)
                          }} >
                          {formatMessage({id:'VIEW_OFFER'})}
                        </AEButton>
                      </td>
                    </tr>
                  ))
              }

              </tbody>
            </table>
          </div>
          {/* end::Table */}
        </div>
        {/* end::Body */}
      </div>
      {/* end::Base Table Widget 6 */}
    </>
  );
}
